import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import './Header.css';
import logo from '../images/logo-rr-news.png';
import NotificationBell from './NotificationBell';
import InstallButton from './InstallButton';

function Header() {
  const [searchQuery, setSearchQuery] = useState('');
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      const cleaned = searchQuery.trim().toLowerCase();

      // If the user explicitly searched for 'ujala' (English or Hindi variants), go to the ujala category page
      const ujalaKeywords = ['rr news', 'rr', 'आर आर न्यूज़', 'rr news tv', 'fastest update'];
      if (ujalaKeywords.some(k => cleaned.includes(k))) {
        navigate('/category/ujala');
        setSearchQuery('');
        return;
      }

      // Otherwise, if user is browsing a category (e.g. /category/ujala), keep the category in the search
      const parts = location.pathname.split('/').filter(Boolean);
      let url = `/search?q=${encodeURIComponent(searchQuery)}`;
      if (parts[0] === 'category' && parts[1]) {
        url += `&category=${encodeURIComponent(parts[1])}`;
      }
      navigate(url);
      setSearchQuery('');
    }
  };

  return (
    <header className="header">
      <div className="header-top">
        <div className="container header-container">
          <Link to="/" className="logo" aria-label="RR News Home">
            <div className="logo-wrap">
              <img src={logo} alt="RR News Logo" className="site-logo" width="84" height="84" />
              <div className="logo-text">
                <span className="brand">RR NEWS TV</span>
                <span className="update-text" >FASTEST UPDATE</span>
                <span className="logo-subtitle">खबर आपकी, नज़र हमारी</span>
              </div>
            </div>
          </Link>

          <form className="search-box" onSubmit={handleSearch} role="search">
            <input
              type="text"
              placeholder="खबर खोजें..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              aria-label="Search news"
            />
            <button type="submit" className="search-btn" aria-label="Search">
              🔍
            </button>
          </form>

          <div className="header-actions">
            <InstallButton />
            <NotificationBell />
            <Link to="/public-upload" className="live-tv-btn live-tv-desktop">
              Public Upload
            </Link>

            <nav className="nav-links" aria-label="Main navigation">
              <Link to="/category/ujala" className="ujala-link">RR NEWS</Link>
              <Link to="/category/india" className="nav-item">इंडिया</Link>
              <Link to="/category/world" className="nav-item">विश्व</Link>
            </nav>

            <Link to="/admin/login" className="btn-login">Reporter Login</Link>

            <button 
              className="menu-toggle"
              onClick={() => setMenuOpen(!menuOpen)}
              aria-expanded={menuOpen}
              aria-label="Toggle menu"
            >
              ☰
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="mobile-menu">
          <nav className="mobile-nav">
            <Link to="/public-upload" onClick={() => setMenuOpen(false)} className="mobile-livetv">Public Upload</Link>
            <Link to="/" onClick={() => setMenuOpen(false)}>होम</Link>
            <Link to="/category/india" onClick={() => setMenuOpen(false)}>इंडिया</Link>
            <Link to="/category/world" onClick={() => setMenuOpen(false)}>विश्व</Link>
            <Link to="/category/sports" onClick={() => setMenuOpen(false)}>खेल</Link>
            <Link to="/category/entertainment" onClick={() => setMenuOpen(false)}>मनोरंजन</Link>
            <Link to="/category/ujala" onClick={() => setMenuOpen(false)} className="mobile-ujala">RR NEWS TV</Link>
            <Link to="/admin/login" onClick={() => setMenuOpen(false)} className="mobile-login">Reporter Login</Link>
          </nav>
        </div>
      )}
    </header>
  );
}

export default Header;
